<template>
  <div class="atlas">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="主图集" name="mainAtlas"><MyAtlas v-if="activeName === 'mainAtlas'" :active-item="activeItem" :activer="activeName" @close="close" /></el-tab-pane>
      <el-tab-pane label="子图集" name="subgraphSet"><MyAtlas v-if="activeName === 'subgraphSet'" :active-item="activeItem" :activer="activeName" @close="close" /></el-tab-pane>
    </el-tabs>

    <!-- <div class="buttonArea">
      <el-button type="primary">确 定</el-button>
    </div> -->
  </div>
</template>

<script>
import MyAtlas from './myAtlas.vue'
export default {
  components: {
    MyAtlas
  },
  props: {
    activeItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      activeName: 'mainAtlas'
    }
  },
  created() {
    console.log('111', this.activeItem)
  },
  methods: {
    handleClick(val) {
      // console.log('val', val, this.activeName)
      // if(this.activeName === 'mainAtlas'){
      //  console.log('')
      // }
    },
    close() {
      this.$emit('closer')
      console.log('关闭')
    }
  }
}
</script>

<style scoped>
.buttonArea{
  display: flex;
  justify-content: flex-end;
}
</style>
